import { useParams } from 'react-router-dom';

export const useResidentId = (): string => {
  const { resident_id } = useParams();

  if (typeof resident_id !== 'string') {
    throw new Error('Unexpected resident_id type');
  }

  return resident_id;
};
